module.exports = __webpack_public_path__ + "8b0e1127ddfaaa6dcc782da875f79b8d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GB-NIR.svg
// module id = 2VVG
// module chunks = 0